import mrpHeroBannerTitleStyle from '../mrp/heroBannerTitle'

export default {
  ...mrpHeroBannerTitleStyle,
  loyaltyFontStyle: {
    fontWeight: 400,
    fontSize: '30px',
    lineHeight: '37.5px',
    textAlign: 'center',
    'screen-large': {
      fontSize: '38px',
      lineHeight: '47.5px',
      fontWeight: 400,
      textAlign: 'center'
    }
  }
}
